import { render } from "./TestRequirements.vue?vue&type=template&id=56507447&scoped=true"
import script from "./TestRequirements.vue?vue&type=script&lang=js"
export * from "./TestRequirements.vue?vue&type=script&lang=js"

import "./TestRequirements.vue?vue&type=style&index=0&id=56507447&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56507447"]])

export default __exports__